import {

    useCallback,

    useEffect,

    useMemo,

    useState,

} from "react";

import CrudModal from "components/crud/CrudModal";

import CrudInput from "components/crud/CrudInput";

import CrudSelect from "components/crud/CrudSelect";

import {

    createExpense,

    getExpense,

    updateExpense,

    uploadExpenseReceipt,

    approveExpense,

    updateTeamLeaderRemark,

    updateAdminRemark,
    updateApprovedAmountByAdmin,

} from "services/api/expenseApi";

import { getEmployee } from "services/api/employeeApi";

import { getVisits, getVisitRoute } from "services/api/visitApi";

import { getAttendances } from "services/api/attendanceApi";

import { showSuccess, showError } from "utils/toast";

/* ================================================================

   CONSTANTS

   ================================================================ */

const EMPTY_ITEM = {

    expenseType: "travel",

    travelBy: "",

    title: "",

    description: "",

    claimedAmount: "",

    allowedAmount: "",

    approvedAmount: "",

    fromLocation: "",

    toLocation: "",

    distanceKm: "",

    billNo: "",

    billDate: "",

    uploadedFilePath: "",

    receiptPreview: "",

    uploadingReceipt: false,

};

const INITIAL_FORM = {

    expenseDate: "",

    visitId: "",

    attendanceId: "",

    journeyPlanAmount: "",

    remarks: "",

    teamLeaderRemark: "",

    adminRemark: "",

    items: [{ ...EMPTY_ITEM }],

};

const EXPENSE_TYPES = [

    { value: "travel", label: "Travel" },

    { value: "food", label: "Food" },

    { value: "fixed DA", label: "Fixed DA" },

    { value: "stay", label: "Stay" },

    { value: "fuel", label: "Fuel" },

    { value: "phone", label: "Phone" },

    { value: "toll", label: "Toll" },

    { value: "other", label: "Other" },

];

const TRAVEL_BY_OPTIONS = [

    { value: "", label: "Select Travel By" },

    { value: "four_wheeler", label: "Four Wheeler" },

    { value: "two_wheeler", label: "Two Wheeler" },

    { value: "public_transport", label: "Public Transport" },

];

const RECEIPT_ACCEPT =

    "image/jpeg,image/png,image/webp,application/pdf";

const ALLOWED_RECEIPT_TYPES = [

    "image/jpeg",

    "image/png",

    "image/webp",

    "application/pdf",

];

const getReceiptUrl = (filePath) => {

    if (!filePath) return "";

    if (/^https?:\/\//i.test(filePath)) {

        return filePath;

    }

    const filename = filePath.replace(/^\/+/, "");

    return `http://localhost:5000/uploads/${filename}`;

};

const MAX_RECEIPT_SIZE = 5 * 1024 * 1024;

/* ================================================================

   HELPERS

   ================================================================ */

const normalizeId = (value) =>

    value === null || value === undefined || value === ""

        ? ""

        : String(value);

const formatDateForInput = (value) => {

    if (!value) return "";

    return String(value).substring(0, 10);

};

const labelize = (value) => {

    if (!value) return "";

    return String(value)

        .replace(/_/g, " ")

        .replace(/\b\w/g, (char) => char.toUpperCase());

};

const extractVisits = (response) =>

    response?.data?.visits ||

    response?.data?.data?.visits ||

    response?.visits ||

    [];

const extractAttendances = (response) =>

    response?.data?.attendances ||

    response?.data?.data?.attendances ||

    response?.attendances ||

    [];

const extractEmployee = (response) =>

    response?.data?.employee ||

    response?.data?.data?.employee ||

    response?.employee ||

    response?.data?.data ||

    null;

const getJourneyPlanClaimAmount = (visit) => {

    const value =

        visit?.journeyPlanItem?.claimAmount ??

        visit?.journeyPlanItem?.claim_amount ??

        visit?.claimAmount ??

        visit?.claim_amount;

    if (value === null || value === undefined || value === "") {

        return "";

    }

    const number = Number(value);

    return Number.isFinite(number) ? number.toFixed(2) : "";

};

const calculatePolicyAmount = (employee, expenseType, travelBy) => {

    if (!employee) return "";

    const localDA = Number(

        employee.daLocalWorking ?? employee.da_local_working ?? 0

    );

    const fooding = Number(

        employee.daOutstationFooding ?? employee.da_outstation_fooding ?? 0

    );

    const lodging = Number(

        employee.daOutstationLodging ?? employee.da_outstation_lodging ?? 0

    );

    const sameDay = Number(

        employee.daOutstationSameDayReturn ??

            employee.da_outstation_same_day_return ??

            0

    );

    const mobile = Number(

        employee.mobileInternetMonthly ??

            employee.mobile_internet_monthly ??

            0

    );

    const localTwoWheeler = Number(

        employee.localTwoWheelerPerKm ??

            employee.local_two_wheeler_per_km ??

            0

    );

    const outstationTwoWheeler = Number(

        employee.outstationTwoWheelerPerKm ??

            employee.outstation_two_wheeler_per_km ??

            localTwoWheeler

    );

    const localCar = Number(

        employee.localCarPerKm ?? employee.local_car_per_km ?? 0

    );

    const outstationCar = Number(

        employee.outstationCarPerKm ??

            employee.outstation_car_per_km ??

            localCar

    );

    switch (expenseType) {

        case "travel":

        case "fuel":

            if (travelBy === "two_wheeler" && localTwoWheeler > 0) {

                return `₹ ${localTwoWheeler.toFixed(2)} / KM`;

            }

            if (travelBy === "four_wheeler" && localCar > 0) {

                return `₹ ${localCar.toFixed(2)} / KM`;

            }

            if (travelBy === "public_transport") {

                return "As per actual / bill";

            }

            return "";

        case "food":

            return fooding > 0

                ? `₹ ${fooding.toFixed(2)} / Day`

                : localDA > 0

                    ? `₹ ${localDA.toFixed(2)} / Day`

                    : "";

        case "stay":

            return lodging > 0 ? `₹ ${lodging.toFixed(2)} / Day` : "";

        case "phone":

            return mobile > 0 ? `₹ ${mobile.toFixed(2)} / Month` : "";

        case "other":

            return sameDay > 0 ? `₹ ${sameDay.toFixed(2)} / Day` : "";

        default:

            return "";

    }

};

const extractRoutePoints = (response) => {

    const route =

        response?.data?.route ||

        response?.data?.data?.route ||

        response?.route ||

        response?.data?.routePoints ||

        response?.data?.data?.routePoints ||

        response?.routePoints ||

        response?.data?.data ||

        response?.data ||

        [];

    if (Array.isArray(route)) return route;

    if (Array.isArray(route?.points)) return route.points;

    if (Array.isArray(route?.routePoints)) return route.routePoints;

    return [];

};

const routeAddress = (point) =>

    point?.address || point?.location || point?.name || "";

const routeDistance = (point) => {

    const value =

        point?.distanceFromPreviousKm ??

        point?.distance_from_previous_km ??

        point?.distanceKm ??

        point?.distance_km ??

        0;

    const number = Number(value);

    return Number.isFinite(number) ? number : 0;

};

const calculateRouteSummary = (points = []) => {

    if (!Array.isArray(points) || !points.length) {

        return { fromLocation: "", toLocation: "", distanceKm: "" };

    }

    const sorted = [...points].sort(

        (a, b) => Number(a?.sequence || 0) - Number(b?.sequence || 0)

    );

    const distance = sorted.reduce(

        (total, point) => total + routeDistance(point),

        0

    );

    return {

        fromLocation: routeAddress(sorted[0]),

        toLocation: routeAddress(sorted[sorted.length - 1]),

        distanceKm: distance.toFixed(2),

    };

};

const getExistingReceiptPath = (item) => {

    if (!Array.isArray(item?.files) || !item.files.length) return "";

    const file =

        item.files.find((entry) => entry?.fileType === "receipt") ||

        item.files[0];

    return file?.filePath || "";

};

const getCurrentUser = () => {

    try {

        return JSON.parse(localStorage.getItem("user") || "{}");

    } catch {

        return {};

    }

};

const getRoleFlags = () => {

    const user = getCurrentUser();

    const roles = Array.isArray(user?.roles) ? user.roles : [];

    const permissions = Array.isArray(user?.permissions)

        ? user.permissions

        : [];

    return {

        isAdmin: roles.includes("admin") || roles.includes("super_admin"),

        isTeamLeader:

            roles.includes("team_leader") ||

            roles.includes("manager") ||

            roles.includes("regional_manager"),

        canManageExpenses:

            permissions.includes("expenses.manage") ||

            permissions.includes("expenses.approve"),

    };

};

const buildExpenseFormItem = (item) => ({

    ...EMPTY_ITEM,

    id: item?.id ? String(item.id) : "",

    status: item?.status || "",

    expenseType: item?.expenseType || "travel",

    travelBy: item?.travelBy || "",

    title: item?.title || "",

    description: item?.description || "",

    claimedAmount:

        item?.claimedAmount !== null && item?.claimedAmount !== undefined

            ? String(item.claimedAmount)

            : "",

    allowedAmount: item?.allowedAmount || item?.defaultAmount || "",

    approvedAmount:

        item?.approvedAmount !== null && item?.approvedAmount !== undefined

            ? String(item.approvedAmount)

            : "",

    fromLocation: item?.fromLocation || "",

    toLocation: item?.toLocation || "",

    distanceKm:

        item?.distanceKm !== null && item?.distanceKm !== undefined

            ? String(item.distanceKm)

            : "",

    billNo: item?.billNo || "",

    billDate: formatDateForInput(item?.billDate),

    uploadedFilePath: getExistingReceiptPath(item),

});

const buildEditForm = (item) => {

    const groupItems =

        Array.isArray(item?.expenses) && item.expenses.length

            ? item.expenses

            : [item];

    const firstItem = groupItems[0] || item || {};

    const visit =

        firstItem?.visit ||

        item?.visit ||

        {};

    return {

        expenseDate: formatDateForInput(firstItem?.expenseDate || item?.expenseDate),

        visitId: normalizeId(

            firstItem?.visitId ||

            firstItem?.visit?.id ||

            item?.visitId ||

            item?.visit?.id

        ),

        attendanceId: normalizeId(

            firstItem?.attendanceId ||

            firstItem?.attendance?.id ||

            item?.attendanceId ||

            item?.attendance?.id

        ),

        journeyPlanAmount: getJourneyPlanClaimAmount(

            visit?.journeyPlanItem

                ? visit

                : firstItem?.journeyPlanItem

                    ? firstItem

                    : item

        ),

        remarks:

            firstItem?.remarks ||

            item?.remarks ||

            "",

        teamLeaderRemark:

            firstItem?.teamLeaderRemark ??

            firstItem?.team_leader_remark ??

            item?.teamLeaderRemark ??

            item?.team_leader_remark ??

            "",

        adminRemark:

            firstItem?.adminRemark ??

            firstItem?.admin_remark ??

            item?.adminRemark ??

            item?.admin_remark ??

    "",

        items: groupItems.map(buildExpenseFormItem),

    };

};

/* ================================================================

   COMPONENT

   ================================================================ */

export default function ExpenseModal({

    open,

    onClose,

    reload,

    item,

    viewMode = false,

}) {

    const isEdit = Boolean(item) && !viewMode;

    const isView = Boolean(item) && Boolean(viewMode);

    const { isAdmin, isTeamLeader, canManageExpenses } = getRoleFlags();

    // Admin and Team Leader can review/approve expenses.

    // Sales users keep the existing create/edit/submit flow.

    const canAdminReview = isAdmin && canManageExpenses;

    const canTeamLeaderReview = isTeamLeader && canManageExpenses;

    const canReviewExpense = canAdminReview || canTeamLeaderReview;

    const canTeamLeaderRemark = isTeamLeader && canManageExpenses;

    const [loading, setLoading] = useState(false);

    const [loadingVisits, setLoadingVisits] = useState(false);

    const [loadingAttendance, setLoadingAttendance] = useState(false);

    const [loadingEmployee, setLoadingEmployee] = useState(false);

    const [loadingRoute, setLoadingRoute] = useState(false);

    const [visits, setVisits] = useState([]);

    const [attendances, setAttendances] = useState([]);

    const [employee, setEmployee] = useState(null);

    const [form, setForm] = useState(INITIAL_FORM);

    const totalClaimedAmount = useMemo(

        () =>

            form.items.reduce(

                (total, entry) => total + (Number(entry?.claimedAmount) || 0),

                0

            ),

        [form.items]

    );

    const disabled = loading || isView;

    const loadVisits = useCallback(async (date = "") => {

        try {

            setLoadingVisits(true);

            const response = await getVisits(

                1,

                100,

                date ? { visitDate: date } : {}

            );

            const data = extractVisits(response);

            setVisits(Array.isArray(data) ? data : []);

        } catch (error) {

            console.error("Load visits error:", error);

            setVisits([]);

            showError(

                error?.response?.data?.message ||

                    "Unable to load visits."

            );

        } finally {

            setLoadingVisits(false);

        }

    }, []);

    const loadAttendance = useCallback(async () => {

        try {

            setLoadingAttendance(true);

            const response = await getAttendances(1, 100);

            const data = extractAttendances(response);

            setAttendances(Array.isArray(data) ? data : []);

        } catch (error) {

            console.error("Load attendance error:", error);

            setAttendances([]);

        } finally {

            setLoadingAttendance(false);

        }

    }, []);

    const loadEmployeePolicy = useCallback(async (employeeId) => {

        if (!employeeId) {

            setEmployee(null);

            return;

        }

        try {

            setLoadingEmployee(true);

            const response = await getEmployee(employeeId);

            setEmployee(extractEmployee(response));

        } catch (error) {

            console.error("Load employee policy error:", error);

            setEmployee(null);

            showError(

                error?.response?.data?.message ||

                    "Unable to load employee expense policy."

            );

        } finally {

            setLoadingEmployee(false);

        }

    }, []);

    useEffect(() => {

        if (!open) return;

        let cancelled = false;

        const initialDate = item?.expenseDate

            ? formatDateForInput(item.expenseDate)

            : new Date().toISOString().substring(0, 10);

        loadVisits(initialDate);

        loadAttendance();

        const initialize = async () => {

            if (!item) {

                setEmployee(null);

                setForm({

                    ...INITIAL_FORM,

                    expenseDate: initialDate,

                    items: [{ ...EMPTY_ITEM }],

                });

                return;

            }

            let sourceItem = item;

            // Summary rows may not include remarks or receipt-file relations.

            // Load the full record for a single numeric expense ID in view mode.

            if (isView && item?.id && /^\d+$/.test(String(item.id))) {

                try {

                    const response = await getExpense(item.id);

                    const detail =

                        response?.data?.expense ||

                        response?.data?.data?.expense ||

                        response?.data?.data ||

                        response?.expense ||

                        response?.data ||

                        response;

                    if (detail && typeof detail === "object" && !cancelled) {

                        sourceItem = { ...item, ...detail };

                    }

                } catch (error) {

                    console.error("Load full expense details error:", error);

                    // Fall back to the supplied item so the existing modal remains usable.

                }

            }

            if (cancelled) return;

            setForm(buildEditForm(sourceItem));

            const employeeId =

                sourceItem?.employeeId ||

                sourceItem?.employee?.id ||

                sourceItem?.visit?.employeeId ||

                sourceItem?.visit?.employee?.id;

            if (employeeId) loadEmployeePolicy(employeeId);

        };

        initialize();

        return () => {

            cancelled = true;

        };

    }, [open, item, isView, loadVisits, loadAttendance, loadEmployeePolicy]);

    useEffect(() => {

        if (!employee) return;

        setForm((previous) => ({

            ...previous,

            items: previous.items.map((expenseItem) => ({

                ...expenseItem,

                allowedAmount: calculatePolicyAmount(

                    employee,

                    expenseItem.expenseType,

                    expenseItem.travelBy

                ),

            })),

        }));

    }, [employee]);

    const updateField = (key, value) => {

        if (isView) {

            const canEditRemark =

                (key === "teamLeaderRemark" && canTeamLeaderRemark) ||

                (key === "adminRemark" && isAdmin);

            if (!canEditRemark) return;

        }

        setForm((previous) => ({ ...previous, [key]: value }));

    };

    const updateItem = (index, key, value) => {

        if (isView) {

            const canEditApprovedAmount =

                key === "approvedAmount" && canReviewExpense;

            const canEditAdminRemark =

                key === "adminRemark" && isAdmin;

            if (!canEditApprovedAmount && !canEditAdminRemark) return;

        }

        setForm((previous) => {

            const items = [...previous.items];

            items[index] = { ...items[index], [key]: value };

            return { ...previous, items };

        });

    };

    const handleExpenseDateChange = async (date) => {

        if (disabled) return;

        setForm((previous) => ({

            ...previous,

            expenseDate: date,

            visitId: "",

            journeyPlanAmount: "",

            items: previous.items.map((entry) => ({

                ...entry,

                allowedAmount: "",

            })),

        }));

        setEmployee(null);

        await loadVisits(date);

    };

    const visitOptions = useMemo(() => [

        { value: "", label: "Select Visit" },

        ...(Array.isArray(visits)

            ? visits.map((visit) => ({

                  value: String(visit.id),

                  label: `${

                      visit.visitDate

                          ? new Date(visit.visitDate).toLocaleDateString("en-IN")

                          : "-"

                  } - ${

                      visit.school?.name ||

                      visit.party?.name ||

                      visit.purpose ||

                      `Visit #${visit.id}`

                  }`,

              }))

            : []),

    ], [visits]);

    const attendanceOptions = useMemo(() => [

        { value: "", label: "Select Attendance" },

        ...(Array.isArray(attendances)

            ? attendances.map((attendance) => ({

                  value: String(attendance.id),

                  label: `${

                      attendance.workDate

                          ? new Date(attendance.workDate).toLocaleDateString("en-IN")

                          : "-"

                  } - ${

                      attendance.employee?.name ||

                      attendance.employee?.user?.name ||

                      "Attendance"

                  }${attendance.status ? ` - ${attendance.status}` : ""}`,

              }))

            : []),

    ], [attendances]);

    const loadVisitRoute = useCallback(

        async (visitId) => {

            if (!visitId) return;

            try {

                setLoadingRoute(true);

                const response = await getVisitRoute(visitId);

                const points = extractRoutePoints(response);

                const summary = calculateRouteSummary(points);

                if (!summary.fromLocation && !summary.toLocation) return;

                setForm((previous) => ({

                    ...previous,

                    items: previous.items.map((entry) =>

                        entry.expenseType === "travel" || entry.expenseType === "fuel"

                            ? {

                                  ...entry,

                                  fromLocation: summary.fromLocation,

                                  toLocation: summary.toLocation,

                                  distanceKm: summary.distanceKm,

                              }

                            : entry

                    ),

                }));

            } catch (error) {

                console.error("Load visit route error:", error);

            } finally {

                setLoadingRoute(false);

            }

        },

        []

    );

    const handleVisitChange = async (visitId) => {

        if (disabled) return;

        const selectedVisit = visits.find(

            (visit) => String(visit.id) === String(visitId)

        );

        if (!selectedVisit) {

            setEmployee(null);

            setForm((previous) => ({

                ...previous,

                visitId: "",

                journeyPlanAmount: "",

            }));

            return;

        }

        const employeeId =

            selectedVisit?.employeeId || selectedVisit?.employee?.id;

        if (employeeId) await loadEmployeePolicy(employeeId);

        setForm((previous) => ({

            ...previous,

            visitId: String(selectedVisit.id),

            journeyPlanAmount: getJourneyPlanClaimAmount(selectedVisit),

        }));

        if (

            form.items.some(

                (entry) =>

                    entry.expenseType === "travel" ||

                    entry.expenseType === "fuel"

            )

        ) {

            await loadVisitRoute(visitId);

        }

    };

    const handleExpenseTypeChange = async (index, expenseType) => {

        if (disabled) return;

        const current = form.items[index] || EMPTY_ITEM;

        const travel = expenseType === "travel" || expenseType === "fuel";

        setForm((previous) => {

            const items = [...previous.items];

            items[index] = {

                ...items[index],

                expenseType,

                travelBy: travel ? items[index].travelBy : "",

                fromLocation: travel ? items[index].fromLocation : "",

                toLocation: travel ? items[index].toLocation : "",

                distanceKm: travel ? items[index].distanceKm : "",

                allowedAmount: calculatePolicyAmount(

                    employee,

                    expenseType,

                    travel ? current.travelBy : ""

                ),

            };

            return { ...previous, items };

        });

        if (form.visitId && travel) {

            await loadVisitRoute(form.visitId);

        }

    };

    const handleTravelByChange = (index, travelBy) => {

        if (disabled) return;

        setForm((previous) => {

            const items = [...previous.items];

            const entry = items[index];

            items[index] = {

                ...entry,

                travelBy,

                allowedAmount: calculatePolicyAmount(

                    employee,

                    entry.expenseType,

                    travelBy

                ),

            };

            return { ...previous, items };

        });

    };

    const addItem = () => {

        if (disabled) return;

        const routeItem = form.items.find(

            (entry) =>

                entry.expenseType === "travel" ||

                entry.expenseType === "fuel"

        );

        setForm((previous) => ({

            ...previous,

            items: [

                ...previous.items,

                {

                    ...EMPTY_ITEM,

                    fromLocation: routeItem?.fromLocation || "",

                    toLocation: routeItem?.toLocation || "",

                    distanceKm: routeItem?.distanceKm || "",

                },

            ],

        }));

    };

    const removeItem = (index) => {

        if (disabled) return;

        setForm((previous) => ({

            ...previous,

            items:

                previous.items.length > 1

                    ? previous.items.filter((_, i) => i !== index)

                    : [{ ...EMPTY_ITEM }],

        }));

    };

    const validateReceipt = (file) => {

        if (!file) return false;

        if (!ALLOWED_RECEIPT_TYPES.includes(file.type)) {

            showError("Only JPG, PNG, WEBP or PDF files are allowed.");

            return false;

        }

        if (file.size > MAX_RECEIPT_SIZE) {

            showError("Receipt must be 5 MB or smaller.");

            return false;

        }

        return true;

    };

    const handleReceiptChange = async (index, event) => {

        if (disabled) return;

        const file = event.target.files?.[0];

        if (!file || !validateReceipt(file)) {

            event.target.value = "";

            return;

        }

        let preview = "";

        if (file.type.startsWith("image/")) {

            preview = URL.createObjectURL(file);

        }

        setForm((previous) => {

            const items = [...previous.items];

            items[index] = {

                ...items[index],

                receiptPreview: preview,

                uploadingReceipt: true,

            };

            return { ...previous, items };

        });

        try {

            const response = await uploadExpenseReceipt(file);

            const filePath = response?.data?.filePath;

            if (!filePath) throw new Error("Upload response did not contain filePath.");

            setForm((previous) => {

                const items = [...previous.items];

                items[index] = {

                    ...items[index],

                    uploadedFilePath: filePath,

                    uploadingReceipt: false,

                };

                return { ...previous, items };

            });

            showSuccess("Receipt uploaded successfully.");

        } catch (error) {

            if (preview) URL.revokeObjectURL(preview);

            setForm((previous) => {

                const items = [...previous.items];

                items[index] = {

                    ...items[index],

                    uploadedFilePath: "",

                    receiptPreview: "",

                    uploadingReceipt: false,

                };

                return { ...previous, items };

            });

            showError(

                error?.response?.data?.message ||

                    "Unable to upload receipt."

            );

        }

    };

    const removeReceipt = (index) => {

        if (disabled) return;

        const preview = form.items[index]?.receiptPreview;

        if (preview) URL.revokeObjectURL(preview);

        updateItem(index, "receiptPreview", "");

        updateItem(index, "uploadedFilePath", "");

    };

    const validate = () => {

        if (!form.expenseDate) {

            showError("Expense date is required.");

            return false;

        }

        for (let index = 0; index < form.items.length; index += 1) {

            const entry = form.items[index];

            if (!entry.expenseType) {

                showError(`Expense ${index + 1}: expense type is required.`);

                return false;

            }

            if (!entry.title.trim()) {

                showError(`Expense ${index + 1}: title is required.`);

                return false;

            }

            if (!String(entry.claimedAmount).trim()) {

                showError(`Expense ${index + 1}: claimed amount is required.`);

                return false;

            }

            if (Number.isNaN(Number(entry.claimedAmount)) || Number(entry.claimedAmount) < 0) {

                showError(`Expense ${index + 1}: invalid claimed amount.`);

                return false;

            }

            if (entry.uploadingReceipt) {

                showError(`Expense ${index + 1}: please wait for receipt upload.`);

                return false;

            }

        }

        return true;

    };

    const buildPayload = (entry) => ({

        expenseDate: form.expenseDate,

        expenseType: entry.expenseType,

        travelBy: entry.travelBy || undefined,

        visitId: form.visitId || undefined,

        attendanceId: form.attendanceId || undefined,

        title: entry.title.trim(),

        description: entry.description.trim() || undefined,

        claimedAmount: entry.claimedAmount,

        fromLocation: entry.fromLocation.trim() || undefined,

        toLocation: entry.toLocation.trim() || undefined,

        distanceKm: entry.distanceKm || undefined,

        billNo: entry.billNo.trim() || undefined,

        billDate: entry.billDate || undefined,

        remarks: form.remarks.trim() || undefined,

        files: entry.uploadedFilePath

            ? [

                  {

                      filePath: entry.uploadedFilePath,

                      fileType: "receipt",

                      caption: "Expense receipt",

                  },

              ]

            : undefined,

    });

    const handleSubmit = async (event) => {

        event.preventDefault();

        if (loading) return;

        // View mode: Admin can update approved amount + Admin remark.
        // Team Leader remark flow remains unchanged.
        if (isView) {
            if (!isAdmin && !isTeamLeader) return;

            const expenseItems = form.items.filter((entry) => entry?.id);
            if (!expenseItems.length && item?.id) {
                expenseItems.push({ ...form.items[0], id: String(item.id) });
            }
            if (!expenseItems.length) {
                showError("Expense ID is missing. Please reload the details.");
                return;
            }

            try {
                setLoading(true);

                if (isAdmin) {
                    for (const entry of expenseItems) {
                        const expenseId = entry.id;
                        const status = String(entry.status || item?.status || "").toLowerCase();
                        const approvedAmount = String(entry.approvedAmount ?? "").trim();
                        const adminRemark = String(form.adminRemark ?? "").trim();

                        if (status === "approved") {
                            if (
                                approvedAmount === "" ||
                                !Number.isFinite(Number(approvedAmount)) ||
                                Number(approvedAmount) < 0
                            ) {
                                showError("Please enter a valid approved amount.");
                                return;
                            }
                            await updateApprovedAmountByAdmin(expenseId, {
                                approvedAmount,
                                adminRemark,
                            });
                        } else {
                            // Keep existing behavior for pending/unapproved expenses.
                            await updateAdminRemark(expenseId, adminRemark);
                        }
                    }
                    showSuccess("Admin details saved successfully.");
                } else {
                    const teamLeaderRemark = String(form.teamLeaderRemark ?? "").trim();
                    if (!teamLeaderRemark) {
                        showError("Please enter a Team Leader remark.");
                        return;
                    }
                    for (const entry of expenseItems) {
                        await updateTeamLeaderRemark(entry.id, teamLeaderRemark);
                    }
                    showSuccess("Team Leader remark saved successfully.");
                }

                await reload();
                onClose();
            } catch (error) {
                console.error("Expense detail save error:", error);
                showError(
                    error?.response?.data?.message || "Unable to save expense details."
                );
            } finally {
                setLoading(false);
            }
            return;
        }

        if (!validate()) return;

        try {

            setLoading(true);

            
if (isEdit) {
    const entry = form.items[0];
    const expenseId = entry?.id || item?.id;

    if (!expenseId) {
        showError("Expense ID is missing.");
        return;
    }

    // Preserve the existing expense edit flow.
    await updateExpense(expenseId, buildPayload(entry));

    // Persist Admin's approved amount and remark separately.
    if (isAdmin) {
        const approvedAmount = String(entry?.approvedAmount ?? "").trim();
        const adminRemark = String(form.adminRemark ?? "").trim();

        if (approvedAmount !== "") {
            if (!Number.isFinite(Number(approvedAmount)) || Number(approvedAmount) < 0) {
                showError("Please enter a valid approved amount.");
                return;
            }

            await updateApprovedAmountByAdmin(expenseId, {
                approvedAmount,
                adminRemark,
            });
        } else {
            await updateAdminRemark(expenseId, adminRemark);
        }
    }

    showSuccess("Expense updated successfully.");
} else {
    for (const entry of form.items) {
        await createExpense(buildPayload(entry));
    }

    showSuccess(
        `${form.items.length} expense${form.items.length > 1 ? "s" : ""} created successfully.`
    );
}

await reload();
onClose();

        } catch (error) {

            console.error("Expense save error:", error);

            showError(

                error?.response?.data?.message || "Unable to save expense."

            );

        } finally {

            setLoading(false);

        }

    };

    /*

     * View mode approval:

     * Admin can enter approved amount in the same modal.

     * Existing approve API is used so the current approval workflow

     * remains intact. Admin remark is sent as the approval remark.

     */

    const handleApproveExpense = async () => {

        // Approval is strictly Admin-only. Team Leaders can only save remarks.

        if (!isView || !isAdmin) {

            showError("Only Admin can approve expenses.");

            return;

        }

        const approvedItems = form.items.filter((entry) =>
            String(entry?.status || item?.status || "").toLowerCase() === "approved"
        );

        if (approvedItems.length) {
            try {
                setLoading(true);
                for (const entry of approvedItems) {
                    const expenseId = entry?.id || item?.id;
                    const approvedAmount = String(entry?.approvedAmount ?? "").trim();
                    if (!expenseId) {
                        showError("Expense ID is missing. Please reload the details.");
                        return;
                    }
                    if (
                        approvedAmount === "" ||
                        !Number.isFinite(Number(approvedAmount)) ||
                        Number(approvedAmount) < 0
                    ) {
                        showError(`Please enter a valid approved amount for ${labelize(entry?.expenseType) || "expense"}.`);
                        return;
                    }
                    await updateApprovedAmountByAdmin(expenseId, {
                        approvedAmount,
                        adminRemark: String(form.adminRemark ?? "").trim(),
                    });
                }
                showSuccess("Approved amount updated successfully.");
                await reload();
                onClose();
            } catch (error) {
                console.error("Approved amount update error:", error);
                showError(error?.response?.data?.message || "Unable to update approved amount.");
            } finally {
                setLoading(false);
            }
            return;
        }

        const approvableItems = form.items.filter((entry) =>
            ["submitted", "pending", "pending_approval", "team_leader_pending"].includes(entry?.status) ||
            (form.items.length === 1 && !entry?.status)
        );

        if (!approvableItems.length) {

            showError("No submitted expense found to approve.");

            return;

        }

        for (const entry of approvableItems) {

            if (entry?.approvedAmount === "" || entry?.approvedAmount === null || entry?.approvedAmount === undefined) {

                showError(`Approved amount is required for ${labelize(entry?.expenseType) || "expense"}.`);

                return;

            }

            if (Number.isNaN(Number(entry.approvedAmount)) || Number(entry.approvedAmount) < 0) {

                showError(`Please enter a valid approved amount for ${labelize(entry?.expenseType) || "expense"}.`);

                return;

            }

            if (!entry?.id && form.items.length > 1) {

                showError("Expense item ID is missing. Please reload the expense details.");

                return;

            }

        }

        try {

            setLoading(true);

            for (const entry of approvableItems) {

                const expenseId = entry?.id || item.id;

                const adminRemark = String(form.adminRemark || "").trim();

                // Persist Admin remark using its dedicated endpoint before approval.

                if (adminRemark) {

                    await updateAdminRemark(expenseId, adminRemark);

                }

                await approveExpense(expenseId, {

                    approvedAmount: String(entry.approvedAmount).trim(),

                    remarks: adminRemark || undefined,

                });

            }

            showSuccess(

                approvableItems.length > 1

                    ? `All ${approvableItems.length} expenses approved successfully.`

                    : "Expense approved successfully."

            );

            await reload();

            onClose();

        } catch (error) {

            console.error("Expense approval error:", error);

            showError(

                error?.response?.data?.message ||

                (error?.response?.status === 403

                    ? "Only Admin can approve expenses."

                    : "Unable to approve expense.")

            );

        } finally {

            setLoading(false);

        }

    };

    const handleClose = () => {

        if (loading) return;

        form.items.forEach((entry) => {

            if (entry?.receiptPreview) {

                URL.revokeObjectURL(entry.receiptPreview);

            }

        });

        setForm({

            ...INITIAL_FORM,

            items: [{ ...EMPTY_ITEM }],

        });

        onClose();

    };

    const showRouteFields = (type) =>

        type === "travel" || type === "fuel";

    const showBillFields = (type) => type !== "phone";

    if (!open) return null;

    const title = isView

        ? "Expense Details"

        : isEdit

            ? "Edit Expense"

            : "Create Expense";

    return (

        <CrudModal

            open={open}

            onClose={handleClose}

            onSubmit={handleSubmit}

            loading={loading}

            title={title}

            submitText={isEdit ? "Update" : "Save"}

            width="max-w-6xl"

        >

            {/* ============================================================

                TOP INFORMATION

            ============================================================ */}

            <div className="mb-5 grid grid-cols-1 gap-4 md:grid-cols-2">

                <CrudInput

                    label="Expense Date"

                    type="date"

                    value={form.expenseDate}

                    onChange={(event) =>

                        handleExpenseDateChange(event.target.value)

                    }

                    disabled={disabled}

                    required

                />

                <CrudSelect

                    label={loadingVisits ? "Visit (Loading...)" : "Visit"}

                    value={form.visitId}

                    onChange={(event) => handleVisitChange(event.target.value)}

                    options={visitOptions}

                    disabled={disabled || loadingVisits}

                />

                <CrudInput

                    label="Journey Plan Estimated Amount"

                    type="text"

                    value={

                        form.journeyPlanAmount

                            ? `₹ ${form.journeyPlanAmount}`

                            : "₹ 0.00"

                    }

                    readOnly

                />

                <CrudSelect

                    label={

                        loadingAttendance

                            ? "Attendance (Loading...)"

                            : "Attendance"

                    }

                    value={form.attendanceId}

                    onChange={(event) =>

                        updateField("attendanceId", event.target.value)

                    }

                    options={attendanceOptions}

                    disabled={disabled || loadingAttendance}

                />

                <CrudInput

                    label="Total Expense Amount"

                    type="text"

                    value={`₹ ${totalClaimedAmount.toFixed(2)}`}

                    readOnly

                />

                <div className="md:col-span-2">

                    <CrudInput

                        label="Expense Remark"

                        value={form.remarks}

                        onChange={(event) =>

                            updateField("remarks", event.target.value)

                        }

                        disabled={disabled}

                    />

                </div>

                <div className="md:col-span-2 lg:col-span-1">

                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">

                        Team Leader Remark

                    </label>

                    <textarea

                        rows={3}

                        value={form.teamLeaderRemark}

                        onChange={(event) =>

                            updateField("teamLeaderRemark", event.target.value)

                        }

                        disabled={!canTeamLeaderRemark}

                        className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-700 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-50 disabled:bg-gray-50 disabled:text-gray-500"

                        placeholder="Team leader remark"

                    />

                </div>

                <div className="md:col-span-2 lg:col-span-1">

                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">

                        Admin Remark

                    </label>

                    <textarea

                        rows={3}

                        value={form.adminRemark}

                        onChange={(event) =>

                            updateField("adminRemark", event.target.value)

                        }

                        disabled={!isAdmin || (!isView && !isEdit)}

                        className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-700 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-50 disabled:bg-gray-50 disabled:text-gray-500"

                        placeholder="Admin remark"

                    />

                </div>

            </div>

            {loadingRoute && (

                <div className="mb-4 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-700">

                    Loading visit route and distance...

                </div>

            )}

            {/* ============================================================

                EXPENSE ITEMS

            ============================================================ */}

            <div className="mb-4 flex items-center justify-between gap-3">

                <div>

                    <h3 className="text-lg font-bold text-navy-700 dark:text-white">

                        Expense Items

                    </h3>

                    <p className="mt-1 text-xs text-gray-500">

                        Actual expenses submitted against the selected visit.

                    </p>

                </div>

                {!isEdit && !isView && (

                    <button

                        type="button"

                        onClick={addItem}

                        disabled={loading}

                        className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-700 disabled:opacity-50"

                    >

                        + Add Expense

                    </button>

                )}

            </div>

            {form.items.map((entry, index) => (

                <div

                    key={index}

                    className="mb-5 rounded-xl border border-gray-200 bg-gray-50 p-4"

                >

                    <div className="mb-4 flex items-center justify-between">

                        <h4 className="font-semibold text-gray-800">

                            Expense #{index + 1}

                        </h4>

                        {!isEdit && !isView && (

                            <button

                                type="button"

                                onClick={() => removeItem(index)}

                                disabled={loading}

                                className="rounded-lg bg-red-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-red-700 disabled:opacity-50"

                            >

                                Remove

                            </button>

                        )}

                    </div>

                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">

                        <CrudSelect

                            label="Expense Type"

                            value={entry.expenseType}

                            onChange={(event) =>

                                handleExpenseTypeChange(index, event.target.value)

                            }

                            options={EXPENSE_TYPES}

                            disabled={disabled}

                        />

                        {showRouteFields(entry.expenseType) && (

                            <CrudSelect

                                label="Travel By"

                                value={entry.travelBy}

                                onChange={(event) =>

                                    handleTravelByChange(index, event.target.value)

                                }

                                options={TRAVEL_BY_OPTIONS}

                                disabled={disabled}

                            />

                        )}

                        <CrudInput

                            label={

                                loadingEmployee

                                    ? "Employee Policy / Allowed Amount (Loading...)"

                                    : "Employee Policy / Allowed Amount"

                            }

                            type="text"

                            value={entry.allowedAmount || ""}

                            readOnly

                            disabled={loadingEmployee}

                        />

                        <CrudInput

                            label="Actual Claimed Amount"

                            type="number"

                            min="0"

                            step="0.01"

                            value={entry.claimedAmount}

                            onChange={(event) =>

                                updateItem(index, "claimedAmount", event.target.value)

                            }

                            disabled={disabled}

                            required

                        />

                        {isAdmin && (

                            <CrudInput

                                label="Approved Amount"

                                type="number"

                                min="0"

                                step="0.01"

                                value={entry.approvedAmount}

                                onChange={(event) =>

                                    updateItem(

                                        index,

                                        "approvedAmount",

                                        event.target.value

                                    )

                                }

                                disabled={loading || !isAdmin || (!isView && !isEdit)}

                            />

                        )}

                        <CrudInput

                            label="Title"

                            value={entry.title}

                            onChange={(event) =>

                                updateItem(index, "title", event.target.value)

                            }

                            disabled={disabled}

                            required

                        />

                        <div className="md:col-span-2 lg:col-span-3">

                            <CrudInput

                                label="Description"

                                value={entry.description}

                                onChange={(event) =>

                                    updateItem(index, "description", event.target.value)

                                }

                                disabled={disabled}

                            />

                        </div>

                        {showRouteFields(entry.expenseType) && (

                            <>

                                <CrudInput

                                    label={loadingRoute ? "From Location (Loading...)" : "From Location"}

                                    value={entry.fromLocation}

                                    onChange={(event) =>

                                        updateItem(index, "fromLocation", event.target.value)

                                    }

                                    disabled={disabled || loadingRoute}

                                />

                                <CrudInput

                                    label={loadingRoute ? "To Location (Loading...)" : "To Location"}

                                    value={entry.toLocation}

                                    onChange={(event) =>

                                        updateItem(index, "toLocation", event.target.value)

                                    }

                                    disabled={disabled || loadingRoute}

                                />

                                <CrudInput

                                    label="Distance (KM)"

                                    type="number"

                                    min="0"

                                    step="0.01"

                                    value={entry.distanceKm}

                                    onChange={(event) =>

                                        updateItem(index, "distanceKm", event.target.value)

                                    }

                                    disabled={disabled}

                                />

                            </>

                        )}

                        {showBillFields(entry.expenseType) && (

                            <CrudInput

                                label="Bill No."

                                value={entry.billNo}

                                onChange={(event) =>

                                    updateItem(index, "billNo", event.target.value)

                                }

                                disabled={disabled}

                            />

                        )}

                        {showBillFields(entry.expenseType) && (

                            <CrudInput

                                label="Bill Date"

                                type="date"

                                value={entry.billDate}

                                onChange={(event) =>

                                    updateItem(index, "billDate", event.target.value)

                                }

                                disabled={disabled}

                            />

                        )}

                        {/* ====================================================

                            RECEIPT

                        ==================================================== */}

                        <div className="md:col-span-2 lg:col-span-3 rounded-xl border border-gray-200 bg-white p-4">

                            <label className="mb-2 block text-sm font-semibold text-navy-700">

                                Receipt

                            </label>

                            {!isView && (

                                <>

                                    <input

                                        id={`expenseReceipt-${index}`}

                                        type="file"

                                        accept={RECEIPT_ACCEPT}

                                        onChange={(event) =>

                                            handleReceiptChange(index, event)

                                        }

                                        disabled={

                                            entry.uploadingReceipt || loading

                                        }

                                        className="block w-full rounded-xl border border-gray-300 bg-white px-3 py-3 text-sm text-gray-700"

                                    />

                                    <p className="mt-1 text-xs text-gray-500">

                                        JPG, PNG, WEBP or PDF. Maximum 5 MB.

                                    </p>

                                </>

                            )}

                            {entry.uploadingReceipt && (

                                <div className="mt-3 rounded-lg bg-blue-50 px-3 py-2 text-sm text-blue-700">

                                    Uploading receipt...

                                </div>

                            )}

                            {entry.uploadedFilePath && !entry.uploadingReceipt && (

                                <div className="mt-3 rounded-lg border border-gray-200 bg-gray-50 p-3">

                                    <div className="flex items-center justify-between gap-3">

                                        <a

    href={

        /^https?:\/\//i.test(entry.uploadedFilePath)

            ? entry.uploadedFilePath

            : `http://localhost:5000/uploads/${String(

                  entry.uploadedFilePath

              ).replace(/^\/+/, "")}`

    }

    target="_blank"

    rel="noopener noreferrer"

    className="break-all text-xs font-medium text-blue-600 underline hover:text-blue-800"

>

    Open / Download Receipt

</a>

                                        {!isView && (

                                            <button

                                                type="button"

                                                onClick={() => removeReceipt(index)}

                                                className="shrink-0 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-xs font-semibold text-gray-600 hover:bg-gray-50"

                                            >

                                                Remove

                                            </button>

                                        )}

                                    </div>

                                    {entry.receiptPreview && (

                                        <img

                                            src={entry.receiptPreview}

                                            alt="Receipt preview"

                                            className="mt-3 max-h-56 max-w-full rounded-lg border border-gray-200 object-contain"

                                        />

                                    )}

                                </div>

                            )}

                        </div>

                    </div>

                </div>

            ))}

            {/* ============================================================

                VIEW MODE / ADMIN APPROVAL ACTION

            ============================================================ */}

            {isView && isAdmin && (

                <div className="mt-4 flex justify-end border-t border-gray-200 pt-4">

                    <button

                        type="button"

                        onClick={handleApproveExpense}

                        disabled={loading || form.items.length === 0 || form.items.some((entry) => (entry?.status === "submitted" || form.items.length === 1) && entry?.approvedAmount === "")}

                        className="rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 transition hover:border-green-200 hover:bg-green-50 hover:text-green-700 disabled:cursor-not-allowed disabled:opacity-50"

                    >

                        {form.items.some((entry) => String(entry?.status || item?.status || "").toLowerCase() === "approved")
                            ? "Update Approved Amount"
                            : "Approve Expense"}

                    </button>

                </div>

            )}

        </CrudModal>

    );

}
